import React, { useRef, useState, useEffect } from 'react';

import Loader from '../Loader';
import nextArrow from '../../imgs/svgs/nextArrow.svg';
import prevArrow from '../../imgs/svgs/prevArrow.svg';

import Movie from '../Movie';
import { Carousel, Controls } from './MoviesStyle';

const Movies = ({ rowtitle, movies, classes }) => {
  const [activeState] = useState('');
  const [count, setCount] = useState(0);
  const [deleteBtn] = useState(false);

  const slide = useRef();
  // this var is to make the slider slide 5 times instead of
  // using the individual movies as a unit of measurement to scroll by
  const screenScroll = movies.length / 3;

  useEffect(() => {
    // animate slider
    slide.current.style = `transform: translateX(-${
      count * (70 / screenScroll)
    }%)`;
  }, [count, screenScroll]);

  const handleSliderClick = (action) => {
    if (action === 'prev') {
      if (count >= 1) {
        setCount((prev) => prev - 1);
      }
    }
    if (action === 'next') {
      if (count <= screenScroll) {
        setCount((prev) => prev + 1);
      }
    }
  };

  if (!movies) {
    return <Loader />;
  }

  return (
    <div className={`container ${classes}`}>
      <h4>{rowtitle}</h4>
      <Carousel>
        <div ref={slide} className={`movies ${activeState}`}>
          {movies.map((movie) => {
            if (movie.title) {
              return (
                <Movie key={movie.id} movie={movie} deleteBtn={deleteBtn} />
              );
            }
            return null;
          })}
        </div>
      </Carousel>

      <Controls className='controls'>
        <button onClick={() => handleSliderClick('prev')}>
          <img src={prevArrow} alt='prev' />
        </button>
        <button onClick={() => handleSliderClick('next')}>
          <img src={nextArrow} alt='next' />
        </button>
      </Controls>
    </div>
  );
};

export default Movies;
